export default __webpack_public_path__ + "static/media/back_arrow.20b629af.svg";